import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Section } from './ui/Section';
export function GuaranteeSection() {
  return <Section background="cream" data-id="element-73">
      <div className="max-w-3xl mx-auto text-center" data-id="element-74">
        <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-md text-[#2C7A7B]" data-id="element-75">
          <ShieldCheck className="w-10 h-10" data-id="element-76" />
        </div>

        <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6" data-id="element-77">
          Garantía de Hierro de 30 Días
        </h2>

        <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-78">
          Prueba el método completo durante 30 días. Si no ves tu hogar más
          limpio, ordenado y liviano, o si simplemente sientes que no es para
          ti, te devolvemos el 100% de tu dinero.
        </p>

        <div className="flex justify-center gap-8 text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-79">
          <span data-id="element-80">Sin preguntas</span>
          <span data-id="element-81">•</span>
          <span data-id="element-82">Sin riesgos</span>
          <span data-id="element-83">•</span>
          <span data-id="element-84">Sin letra chica</span>
        </div>
      </div>
    </Section>;
}